import 'perfect-scrollbar/css/perfect-scrollbar.css'
import './css/dx.material.brands.css'
import './css/index.css'

import React from 'react'
import { createRoot } from 'react-dom/client'

import { LicenseInfo } from '@mui/x-license'
import * as Sentry from '@sentry/react'
import config from 'devextreme/core/config'

import { ErrorBoundary } from '@/components/core/error-boundary'

import App from './App'

window.global ||= window

Sentry.init({
  dsn: 'https://fa467857421d5db4a59d1aac07a03dd6@o289996.ingest.us.sentry.io/4508053398880256',
  integrations: [Sentry.browserTracingIntegration(), Sentry.extraErrorDataIntegration()],
  tracesSampleRate: 0.1,
  environment: process.env.REACT_APP_ENV,
  enabled: process.env.REACT_APP_ENV === 'production',
  enableLogs: true,
})

// Builds only: the key is perpetual for these versions but expired for dev, where x v7 throws on it.
// Unset in dev means an unlicensed watermark instead of a crash.
if (import.meta.env.PROD) {
  LicenseInfo.setLicenseKey(
    '31138f439701c5687f4c1e9366b82a1eTz04MjcwNixFPTE3Mzc1NjY0ODIwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
  )
}

config(
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImRhYmNhMDc2LTVmZGYtMTFlNC04MGMwLTAwMjU5MGQ5ZDVmZiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.b8KkLgI0uX71NJIpAFwXX9vgZEuU0Iurg48lqkv/LZKY0SWjbyJD1U/bZsFVejpkntHxXg74wDXzjtodyauJnH5QSSnjuDgr1kR3RWC4TSjF3ovaHvqdWKZVLYLnRbapZwRbCw==',
)

const rootElement = document.getElementById('root')
// React 19 stopped rethrowing render errors globally; these hooks are the only way Sentry still sees them.
// onCaughtError is omitted on purpose - Sentry.ErrorBoundary already reports those.
const root = createRoot(rootElement, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
})

root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
)
